import { render, staticRenderFns } from "./LightboxAudio.vue?vue&type=template&id=2be34600&scoped=true"
import script from "./LightboxAudio.vue?vue&type=script&lang=js"
export * from "./LightboxAudio.vue?vue&type=script&lang=js"
import style0 from "./LightboxAudio.vue?vue&type=style&index=0&id=2be34600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be34600",
  null
  
)

export default component.exports